"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResetButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ResetButton = _ref => {
  let {
    activeFilterIds,
    satActiveFilterIds
  } = _ref;
  const {
    11: resetAll
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return /*#__PURE__*/_react.default.createElement(_material.Chip, {
    sx: {
      opacity: activeFilterIds.length ? 1 : 0,
      pointEvents: activeFilterIds.length ? 'pointer' : 'none',
      borderColor: 'transparent',
      textDecoration: 'underline',
      transition: 'all .2s'
    },
    color: "default",
    variant: "outlined",
    label: resetAll,
    onClick: () => satActiveFilterIds([])
  });
};
exports.ResetButton = ResetButton;
ResetButton.propTypes = {
  activeFilterIds: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  satActiveFilterIds: _propTypes.default.func.isRequired
};